import { CarrierType } from '@planning/app/api'
import { TFnType } from '@tolgee/react'
import { getContainerAttributesParameters, tomTableColumnFilterPresets } from '@tom-ui/ui'
import { MRT_ColumnDef, MRT_RowData } from 'material-react-table'
import { ReleaseStatus } from '../models/ReleaseStatus'
import { getReleaseShippingLineInfo } from './releaseTableHelper'

export const releaseFilterPresets = {
  ...tomTableColumnFilterPresets,

  transportModeMultiSelect: <T extends MRT_RowData>(
    t: TFnType,
  ): Partial<MRT_ColumnDef<T, unknown>> => {
    const validCarrierTypes = Object.values(CarrierType).filter(
      type => type !== CarrierType.Universal,
    )

    return {
      filterVariant: 'multi-select',
      filterSelectOptions: validCarrierTypes.map(status => ({
        label: t(status.toLowerCase()),
        value: status,
      })),
      filterFn: filterStringIncludes,
      enableColumnFilterModes: false,
    }
  },

  typeMultiSelect: <T extends MRT_RowData>(t: TFnType): Partial<MRT_ColumnDef<T, unknown>> => {
    const { types } = getContainerAttributesParameters(t)
    return {
      filterVariant: 'multi-select',
      filterSelectOptions: Object.values(types).map(type => ({
        label: type.label,
        value: type.label,
      })),
      filterFn: filterStringIncludes,
      enableColumnFilterModes: false,
    }
  },

  heightMultiSelect: <T extends MRT_RowData>(t: TFnType): Partial<MRT_ColumnDef<T, unknown>> => {
    const { heights } = getContainerAttributesParameters(t)

    return {
      filterVariant: 'multi-select',
      filterSelectOptions: Object.values(heights).map(height => ({
        label: height.label,
        value: height.label,
      })),
      filterFn: filterStringIncludes,
      enableColumnFilterModes: false,
    }
  },

  statusMultiSelect: <T extends MRT_RowData>(t: TFnType): Partial<MRT_ColumnDef<T, unknown>> => ({
    filterVariant: 'multi-select',
    filterSelectOptions: Object.values(ReleaseStatus).map(status => ({
      label: t(status.toLowerCase()),
      value: status,
    })),
    filterFn: (row, columnId, filterValue) => {
      if (!filterValue || filterValue.length <= 0) return true

      const value = row.getValue<ReleaseStatus>(columnId)
      const filters = [...filterValue]

      return filters.includes(value)
    },
    enableColumnFilterModes: false,
  }),

  operatorFilter: <T extends MRT_RowData>(t: TFnType): Partial<MRT_ColumnDef<T, unknown>> => {
    return {
      filterVariant: 'text',
      enableColumnFilterModes: false,
      filterFn: (row, id, filterValue) => {
        const { name, shortName } = getReleaseShippingLineInfo(row.original as any, t)

        const display = `${name} ${shortName}`

        return display.toLowerCase().includes(filterValue.toLowerCase())
      },
    }
  },
}

const filterStringIncludes = (row: any, columnId: string, filterValue: string[]) => {
  if (filterValue?.length <= 0) return true

  const stringValue = row.getValue(columnId)
  const values = stringValue.split(',').map((v: string) => v.trim())

  return values.some((v: string) => filterValue.includes(v))
}
